export default __webpack_public_path__ + "static/media/blog-image3.16441478.png";